import * as React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { Grid, Select, MenuList, MenuItem, ListItemText, ListItemIcon, Typography, Tooltip, Menu, Button } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import FeedIcon from '@mui/icons-material/Feed';
import IconButton from '@mui/material/IconButton';
import HelpIcon from '@mui/icons-material/Help';
import InfoIcon from '@mui/icons-material/Info';
import LogoutIcon from '@mui/icons-material/Logout';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import CloseIcon from '@mui/icons-material/Close';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import MenuIcon from '@mui/icons-material/Menu';
import { LanguageContext } from './LanguageContext';
import { languageOptions } from './../translations';
import { authFetch, authPost, logOut } from "./../authProvider";
import { FeatureTrim } from './FeatureTrim';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Drawer from '@mui/material/Drawer';
import useMediaQuery from '@mui/material/useMediaQuery';
import ErrorDialog from './ErrorDialog';
import { TiedostoLataus } from './TiedostoLataus';
import cloneDeep from 'lodash.clonedeep';

import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import GradingIcon from '@mui/icons-material/Grading';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';

const icons = {
    certification: WorkspacePremiumIcon,
    dataingestion: CopyAllIcon,
    inventory: GradingIcon,
    simulation: TroubleshootIcon,
    verification: VerifiedUserIcon,
    esrs: BookmarkBorderIcon,

    FeedIcon: FeedIcon,
    HelpIcon: HelpIcon,
    AccountCircleIcon: AccountCircleIcon,
    SettingsIcon: SettingsIcon,
    LogoutIcon: LogoutIcon,
    LanguageIcon: LogoutIcon//LanguageIcon,
      
};

//https://stackoverflow.com/questions/15523514/find-by-key-deep-in-a-nested-array
const findNestedObj = (entireObj, keyToFind, valToFind) => {
    let foundObj;
    JSON.stringify(entireObj, (_, nestedValue) => {
        if (nestedValue && nestedValue[keyToFind] === valToFind) {
            foundObj = nestedValue;
        }
        return nestedValue;
    });
    return foundObj;
};

//TODO:Theme
const ServiceItem = ({ id, title, icon, onClick, external, selected, lang }) => {
    const Icon = Object.keys(icons).indexOf(icon) > -1 ? icons[icon] : icons["HelpIcon"];

    return (
        <MenuItem
            sx={{
                height: "calc((100vh - 160px) / 20)",
                //flex: 1,
                minHeight: "unset",
                borderRight: (selected ? "3px solid #EE8723" : null),
                backgroundColor: (selected ? "#ffffff42" : null),
                "&:hover": {
                    backgroundColor: '#ffffff1e'
                                        
                    }
                }
                
            }
            onClick={() => onClick(id)}
        >
            <ListItemIcon style={{
                minWidth: 40,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fill: "#fff",
            }}
            >
                {icon !== "LanguageIcon" ?
                    <Icon style={{ color: "#fff", fontSize: "24px" }} /> :
                    <Typography style={{ paddingLeft: 2, color: "#F4B266", fontSize: "16px" }}>{lang}</Typography>
                }
            </ListItemIcon>
            <ListItemText className="textLabel" style={{ color: "#fff", paddingLeft: "15px" }}>
                {title}
            </ListItemText>
            {external ? <OpenInNewIcon className="textLabel" style={{ marginLeft: 8, marginTop: 5, color: "#fff", fontSize: "16px" }} /> : null}
        </MenuItem>
    );
}


//TODO:Theme
const SubmenuItem = ({ id, title, description, badge, onClick, external, selected }) => {
    return (
        <Card
            square
            onClick={() => onClick(id)}
            style={{ marginBottom: 16, padding: 8 }}
            sx={{
                borderRight: (selected ? "3px solid #EE8723" : null),
                backgroundColor: (selected ? "#ffffff42" : "transparent"),
                boxShadow: 0,
                "&:hover": {
                    backgroundColor: '#ffffff1e'
                }
            }}
        >
            <div style={{ display: "flex" }} >
                <Typography style={{ color: "#fff", fontWeight: "bold", fontSize: "16px" }} component="div">
                    {title}
                </Typography>
                {external ? <OpenInNewIcon className="textLabel" style={{ marginLeft: 8, marginTop: 5, color: "#fff", fontSize: "16px" }} /> : null}
                <Box sx={{ flexGrow: 1 }} />
                {badge ? <Typography style={{ color: "#fff", backgroundColor: "#EE8723", fontSize: "12px", padding: "3px 6px 3px 6px", borderRadius: 5 }} component="div">{badge}</Typography> : null}
            </div>
            <Typography style={{ color: "#fff", fontSize: "16px" }} component="div">
                {description}
            </Typography>
        </Card>

    );
}

//TODO:Theme
const SubmenuContainer = ({ title, Icon, items, onClick, closeButton }) => {
    return (
        <div style={{ padding: 16 }}>
            <div style={{ display: "flex" }}>
                <div style={{ fill: "#fff" }}>
                    <Icon style={{ color: "#fff", fontSize: 24 }} />
                </div>
                <Typography style={{ marginLeft: 6, color: "#fff", fontWeight: "bold" }} variant="h6" component="div">
                    {title}
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                {closeButton ? <IconButton onClick={() => onClick(false)} sx={{ "&:hover": { backgroundColor: '#ffffff1e' } }}><CloseIcon style={{ color: "#fff" }} /></IconButton> : null}
            </div>
            {items}
        </div>);
}

export class GlobalMenu extends React.Component {
    static contextType = LanguageContext;

    constructor(props) {
        super(props);

        this.state = {
            menu: "0",
            lang: "fi",
            features: [],
            openVuokra: false,
            openVuokrat: false,
            openYlla: false,
            openAsiakas: false,

            isAdmin: false,
            profiili: null,
            data: null,

            showBackdrop: false,
            showSubmenu: false,
            parentObj: null,
            parentId: null,
            selectedObj: null,
            selectedId: this.props.selected,
            redirect: null
        };

        //Profiili
        authFetch(this.props.pca, 'api/Profiili/Read')
            .then(response => response.json())
            .then(data => {
                this.setState({
                    profiili: data,
                    //redirect: !data.termsApproved ? "/terms" : null,
                    lang: (((data || []) || {}).kieli || this.state.lang),
                });
            });

        //featuret
        authFetch(this.props.pca, 'api/Toiminto/Read')
            .then(response => response.json())
            .then(data => {
                var features = data.filter(d => d.aktivoitu).map(d => d.toiminto); //.filter((v, i, a) => a.indexOf(v) == i); //uniikit
                this.setState({ features: features })
            });
    }

    componentDidMount() {
        this.setState({ lang: this.context.userLanguage || this.state.lang })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selected !== this.props.selected) {
            this.setState({ selectedId: this.props.selected });
        }
    }

    handleLogEvent = (e, target, action, info) => {
        if (e) e.preventDefault();

        authPost(this.props.pca, 'api/EventLog/Create', {
            body: JSON.stringify({
                target: target,
                action: action,
                info: info
            })
        })
    }

    handleBackdrop = (value) => {
        this.setState({ showBackdrop: value })
    }

    openSubmenu = (value) => {
        this.setState({ showSubmenu: value, showBackdrop: value });
    }

    handleSubmenu = (value) => {
        const obj = findNestedObj(this.state.navstruct, "id", value);

        if (obj) {
            this.setState({
                showBackdrop: true,
                showSubmenu: true,
                parentObj: obj,
                parentId: value
            });
        }

        this.handleLogEvent(null, "Reports Section", "Click", value);
    }

    handleSubmenuLink = (value) => {
        const obj = findNestedObj(this.state.navstruct, "id", value);
        const url = obj?.link;
        const typeid = obj?.typeId;

        if (typeid == 21) { // SSRS
            const report = obj.lang[this.state.lang].reportId;
            this.setState({
                showBackdrop: false,
                showSubmenu: false,
                redirect: null
            }, () => window.open(url + '&reportpath=' + report, '_blank', 'noopener, noreferrer'));
        } else if (typeid == 20) { // PowerBI
            this.setState({
                showBackdrop: false,
                showSubmenu: false,
                selectedObj: obj,
                selectedId: obj.id,
                redirect: url
            });
        } else {
            this.setState({
                showBackdrop: false,
                showSubmenu: false,
                selectedObj: null,
                selectedId: null,
                redirect: null
            });
        }

        this.handleLogEvent(null, "Reports Link", "Click", ((obj || {}).serviceId) + ';' + url); //TietopalveluAvain;Url
    }

    handleDocuments = (value) => {
        this.setState({
            showBackdrop: false,
            showSubmenu: false,
            parentId: value,
            redirect: "/tiedostot"
        });

        this.handleLogEvent(null, "ReportDocuments", "Click", value);
    }

    handleHome = (value) => {
        this.setState({
            showBackdrop: false,
            showSubmenu: false,
            parentId: value,
            redirect: "/"
        });

        this.handleLogEvent(null, "Home", "Click", value);
    }

    handleHelp = (value) => {
        this.setState({
            showBackdrop: false,
            showSubmenu: false,
            parentId: value,
            redirect: "/help"
        });

        this.handleLogEvent(null, "Help", "Click", "");
    }

    handleProfile = (value) => {
        this.setState({
            showBackdrop: true,
            showSubmenu: true,
            parentId: value,
        });

        this.handleLogEvent(null, "Profile Section", "Click", "");
    }

    handleProfileLink = (value) => {
        this.setState({
            showBackdrop: false,
            showSubmenu: false,
            selectedId: value,
            redirect: value
        });

        this.handleLogEvent(null, "Profile Link", "Click", value);
    }

    handleLogout = () => {
        this.handleLogEvent(null, "Logout", "Click", "");
        logOut(this.props.pca);
    }

    handleService = (value) => {
        this.setState({
            showBackdrop: false,
            showSubmenu: false,
            parentId: value,
            redirect: value
        });

        this.handleLogEvent(null, "Service", "Click", value);
    }

    handleOrganizationChange = (e) => {
        const id = e.target.value;
        let nav = null;

        if (id != this.state.organization) {
            authFetch(this.props.pca, 'api/Profiilit/Activate/' + id)
                .then(response => response.json())
                .then(data => {
                    if (!data.error) {

                        //Navigaatio
                        authFetch(this.props.pca, 'api/Raportti/Navigaatio')
                            .then(response => response.json())
                            .then(data => {
                                nav = data;

                                //Features
                                authFetch(this.props.pca, 'api/Toiminto/Read')
                                    .then(response => response.json())
                                    .then(data => {
                                        var features = data.filter(d => d.aktivoitu).map(d => d.toiminto); //.filter((v, i, a) => a.indexOf(v) == i); //uniikit
                                        this.setState({
                                            navstruct: nav,
                                            features: features,
                                            organization: id,
                                            showBackdrop: false,
                                            showSubmenu: false,
                                            selectedId: null,
                                            parentId: null,
                                            redirect: "/"
                                        })
                                    });
                            });
                    }
                });
        }
    }

    render() {
        const { userLanguage, userLanguageChange, dictionary } = this.context;
        const { features, showBackdrop, showSubmenu, parentObj, selectedObj, selectedId, menu, redirect, navstruct, parentId } = this.state;

        const toggleLanguage = () => {
            let lang = this.state.lang == 'en' ? 'fi' : 'en';
            this.setState({ lang: lang }, () => userLanguageChange(lang))
        }

        const al = dictionary.GlobalMenu.Asetukset;

        const settings = (
            <MenuList
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "calc(100vh - 160px)",
                    padding: 0
                } }
            >
                <Typography
                    className="textLabel" style={{ fontSize: "16px", color: "#EE8723", flex: "0 0 auto", paddingLeft: "15px" }}>{"Entities"}
                </Typography>
                <hr className="hrLine" style={{ border: "1px solid #d77700", background: "#d77700", borderBottom: 0 }} />
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%"
                    }}
                >
                             
                <ServiceItem key={90001} id="/campaign" title="Campaign" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/campaign"} />
                <ServiceItem key={90005} id="/activity" title="Activity" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/activity"} />
                <ServiceItem key={90006} id="/channel" title="Channel" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/channel"} />
                <ServiceItem key={90007} id="/company" title="Company" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/company"} />
                <ServiceItem key={90008} id="/contact" title="Contact" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/contact"} />
                <ServiceItem key={90009} id="/content" title="Content" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/content"} />
                <ServiceItem key={90010} id="/contractors" title="Contractors" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/contractors"} />
                <ServiceItem key={90011} id="/engagement" title="Engagement" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/engagement"} />
                <ServiceItem key={90012} id="/jobroles" title="Jobroles" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/jobroles"} />
                <ServiceItem key={90013} id="/leads" title="Leads" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/leads"} />
                <ServiceItem key={90014} id="/location" title="Location" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/location"} />
                <ServiceItem key={90015} id="/offers" title="Offers" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/offers"} />
                <ServiceItem key={90016} id="/operator" title="Operator" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/operator"} />
                <ServiceItem key={90017} id="/product" title="Product" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/product"} />
                <ServiceItem key={90018} id="/phase" title="Phase" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/phase"} />
                <ServiceItem key={90019} id="/sales" title="Sales" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/sales"} />
                <ServiceItem key={90020} id="/purchase" title="Purchase" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/purchase"} />
                <ServiceItem key={90021} id="/resources" title="Resources" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/resources"} />
                <ServiceItem key={90022} id="/tickets" title="Tickets" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/tickets"} />
                <ServiceItem key={90023} id="/activityFeature" title="ActivityFeature" icon="HelpIcon" onClick={this.handleService} selected={parentId == "/activityFeature"} />

                </Box>

            </MenuList>
        );

        const submenu = () => {
            const obj = parentObj;

            if (parentId == 9993) {
                //9993 = Profiili


                const myitems = [
                    ["Ui_Etusivu_Luku", "/profiilit", dictionary.Profile.Title, dictionary.Profile.Description],
                    ["Ui_Etusivu_Luku", "/terms", dictionary.Terms.Title, dictionary.Terms.Description],
                    ["Ui_Etusivu_Luku", "https://account.activedirectory.windowsazure.com/ChangePassword.aspx", dictionary.Password.Title, dictionary.Password.Description]
                ].map((d, i) => {
                    return (
                        <SubmenuItem key={i} id={d[1]} title={d[2]} description={d[3]} badge={null} onClick={this.handleProfileLink} selected={selectedId == d[1]} />
                    );
                });

                const adminitems = [
                    ["Ui_Asiakas_Muokkaus", "/asiakas", al.Asiakas, al.AsiakasKuvaus],
                    ["Ui_AsiakkaanRoolit_Luku", "/asiakkaanroolit", al.AsiakkaanRoolit, al.AsiakkaanRoolitKuvaus],
                    ["Ui_Koodi_Muokkaus", "/koodi", al.Koodi, al.KoodiKuvaus],
                    ["Ui_Koodiryhma_Muokkaus", "/koodiryhma", al.Koodiryhma, al.KoodiryhmaKuvaus],
                    //["Ui_Raportti_Muokkaus", "/raportit", al.Raportti, al.RaporttiKuvaus],
                    //["Ui_Profiili_Muokkaus", "/profiilit", al.Kayttajat, al.KayttajatKuvaus],
                    ["Ui_Rooli_Muokkaus", "/roolit", al.Roolit, al.RoolitKuvaus],
                    ["Ui_Roolit_Muokkaus", "/profiiliroolit", al.Kayttajienroolit, al.KayttajienroolitKuvaus],
                    ["Ui_RooliOikeudet_Muokkaus", "/roolioikeudet", al.Kayttooikeudet, al.KayttooikeudetKuvaus],
                    ["Ui_Toiminto_Muokkaus", "/toiminnot", al.Toiminnot, al.ToiminnotKuvaus],
                    ["Ui_Palvelupaketti_Muokkaus", "/palvelupaketti", al.Plans, al.PlansKuvaus],
                    //["Ui_Karuselli_Muokkaus", "/karuselli", al.Karuselli, al.KaruselliKuvaus]
                ].map((d, i) => {
                    return (
                        <FeatureTrim key={i * 100} features={features} feature={d[0]}>
                            <SubmenuItem key={i} id={d[1]} title={d[2]} description={d[3]} badge={null} onClick={this.handleProfileLink} selected={selectedId == d[1]} />
                        </FeatureTrim>
                    );
                });

                return (
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        sx={{ height: "100vh", overflowY: "auto" }}
                    >
                        <FeatureTrim features={features} feature={"Ui_Asetukset_Muokkaus"}>
                            <Grid item sx={{ width: 300 }}>
                                <SubmenuContainer
                                    key={1}
                                    title={al.Asetukset}
                                    Icon={SettingsIcon}
                                    items={adminitems}
                                    onClick={this.openSubmenu}

                                />
                            </Grid>
                        </FeatureTrim>
                        <Grid item sx={{ width: 300 }}>
                            <SubmenuContainer
                                key={1}
                                title={dictionary.Profile.Title}
                                Icon={AccountCircleIcon}
                                items={myitems}
                                onClick={this.openSubmenu}
                                closeButton={true}
                            />
                        </Grid>

                    </Grid>
                );

            } else if (obj) {
                // Palvelut/raportit
                const submenuitems = (obj.children || []).map(d => {
                    return (
                        <SubmenuItem key={d.id} id={d.id} title={((d.lang[this.state.lang] || {}).title || "")} description={((d.lang[this.state.lang] || {}).description || "")} badge={(d.lang[this.state.lang] || {}).badge || null} onClick={this.handleSubmenuLink} external={(d.typeId == 21)} selected={selectedId == d.id} />
                    );
                });

                return (
                    <div style={{ width: 400, height: "100vh", overflowY: "auto" }}>
                        <SubmenuContainer
                            title={obj.lang ? obj.lang[this.state.lang].title : ""}
                            Icon={obj.icon ? icons[obj.icon] : HelpIcon}
                            items={submenuitems}
                            onClick={this.openSubmenu}
                            closeButton={true}
                        />
                    </div>
                );

            } else {
                // Ei mitään

                return null;
            }

        }

        const actions = (
            <MenuList style={{ position: "fixed", bottom: 0, width: 58 }}>
                {/*<ServiceItem key={9991} id={9991} title={dictionary.GlobalMenu.Reportdocuments} icon="FeedIcon" onClick={this.handleDocuments} selected={parentId == 9991} />*/}
                <hr style={{ border: "1px solid #d77700", background: "#d77700", borderBottom: 0 }} />
                {/*<ServiceItem key={9993} id={9993} title={dictionary.GlobalMenu.Profile} icon="AccountCircleIcon" onClick={this.handleProfile} selected={parentId == 9993} />*/}
                <ServiceItem key={9994} id={9994} title={dictionary.GlobalMenu.Logout} icon="LogoutIcon" onClick={this.handleLogout} />
                <ServiceItem key={9995} id={9995} title={dictionary.GlobalMenu.Language} icon="LanguageIcon" onClick={toggleLanguage} lang={dictionary.GlobalMenu.LanguageShort} />
            </MenuList>
        );

        const navigateToUrl = (url) => {
            if (url) {
                if (url.startsWith("http")) {
                    window.location.href = url;
                } else {
                    this.setState({ redirect: null, showBackdrop: false });
                    return (<Navigate to={url} state={{ parent: parentObj, item: selectedObj }} />);
                }
            } else {
                return null;
            }
        }

        return (
            <div style={{ zIndex: 1, height: "100%" }}>
                {navigateToUrl(redirect)}
                <Backdrop open={showBackdrop} style={{ zIndex: -1 }}>
                </Backdrop>
                <Box
                    sx={{
                        display: (showSubmenu ? "block" : "none"),
                        zIndex: -1, position: "absolute",
                        left: 58,
                        top: 0,
                        height: "100vh",
                        backgroundColor: "#27735C",
                        boxShadow: 8
                    }}>
                    {submenu()}
                </Box>
                <Box
                    style={{ height: "100vh", width: 58, background: "#000", transition: 'width 0.15s, visibility 2s' }}
                    sx={{
                        overflowX: "hidden",
                        "& .serviceButtons": {
                            width: "75%"
                        },
                        "& .textLabel": {
                            visibility: "hidden",
                        },
                        "& .mainTextLabel": {
                            visibility: "hidden",
                        },
                        "& .hrLine": {
                            visibility: "visible"
                        },
                        '&:hover': {
                            width: "420px !important",
                            "& .serviceButtons": {
                                width: "94%",
                            },
                            "& .textLabel": {
                                visibility: "visible",
                                color: "#fff",

                            },
                            "& .mainTextLabel": {
                                visibility: "visible",
                                paddingLeft: "15px"
                            },
                            "& .hrLine": {
                                visibility: "hidden"
                            },
                            "& ul": {
                                width: "420px !important"
                            },
                        }
                    }}
                >
                    <MenuList>
                        {/* KTI Online */}
                        <ServiceItem key={9999} id={9999} title={dictionary.GlobalMenu.Home} icon="HomeIcon" onClick={this.handleHome} selected={parentId == 9999} />

                    </MenuList>

                    {/* Käyttöoikeudet */}
                    {settings}

                    {/* Perustoiminnot */}
                    {actions}

                </Box>
            </div>
        );
    }
}
